const zhTW = {
    translation: {
        loading: '載入中…',

        pageTitle: {
            home: '首頁',
            crochetGallery: '鉤針編織',
            knitGallery: '棒針編織',
            patternGallery: '織圖教學文件',
            crochetEditor: '鉤針編輯器',
            knitEditor: '棒針編輯器',
            patternEditor: '織圖文件編輯器',
            tryCrochet: '試用鉤針編輯器',
            tryKnit: '試用棒針編輯器',
            settings: '設定',
            licenses: '開放原始碼授權',
            privacy: '隱私權與 Cookie',
            terms: '服務條款',
            whatsNew: '新功能',
            crochetIcons: '鉤針針法圖示',
            iconHandoff: '圖示交付',
            signIn: '登入',
            signUp: '註冊',
            waitlist: '候補名單',
        },

        settings: {
            label: '設定',
            info: '資訊',
            apply: '套用',
            discard: '捨棄',
            applying: '套用中…',
            saved: '設定已儲存',
            customCursor: '自訂游標',
            inputMode: {
                label: '輸入方式',
                mouse: '鍵盤與滑鼠',
                trackpad: '觸控板',
            },
            fontSize: {
                label: '字型大小',
                small: '小',
                medium: '中',
                large: '大',
                'x-large': '特大',
                'xx-large': '超特大',
            },
            bentoRadius: {
                label: '面板圓角',
                description: '編輯器面板（畫布、標題列、屬性欄）的圓角程度。',
                none: '直角',
                small: '微圓',
                medium: '中',
                large: '圓',
                'x-large': '特圓',
            },
            canvasGrid: {
                label: '畫布格線',
                off: '關閉',
                dots: '點狀',
                lines: '線狀',
                ruler: '尺規',
                snapToGrid: '貼齊格線',
            },
            canvasBackground: {
                label: '畫布背景',
                paper: '紙張',
                white: '白色',
                linen: '亞麻',
                stone: '石灰',
                charcoal: '炭灰',
                night: '夜色',
                custom: '自訂顏色',
                saturation: '飽和度與亮度',
                hue: '色相',
                hex: '十六進位色碼',
            },
            grabMode: {
                label: 'G 鍵抓取',
                moveOnly: '僅移動',
                allDrags: '任何拖曳',
            },
            overlays: {
                label: '圖層',
                roundNumbers: '段數',
                stitchOrder: '針目順序',
                guides: '參考線',
            },
        },

        diagrams: {
            title: '我的織圖',
            newDiagram: '新增織圖',
            untitled: '未命名',
            notFound: '找不到這張織圖',
            loadFailed: '無法載入這張織圖——原始資料未被更動',
            createFailed: '無法建立新織圖',
            saveStatus: {
                saving: '儲存中…',
                saved: '已儲存',
                error: '無法儲存',
                tooLarge: '檔案過大無法同步——僅儲存於此裝置',
                synced: '已同步',
                syncing: '同步中…',
                offline: '離線 — 已儲存在此裝置',
            },
            save: '儲存',
            lastSavedToday: '上次儲存於今天 {{time}}',
            lastSavedOn: '上次儲存於 {{date}} {{time}}',
            conflict: '已在其他裝置上修改——請重新載入以取得最新版本',
            offlineList: '目前離線——顯示此裝置上的副本',
            storageUnavailable: '無法使用本機儲存空間——變更將不會被儲存',
            listFailed: '無法載入你的織圖',
            empty: '還沒有織圖——建立你的第一張吧',
            renameLabel: '織圖名稱',
            rename: '重新命名',
            delete: '刪除',
            deleteTitle: '刪除織圖？',
            deleteBody: '「{{name}}」將被永久刪除。',
            cancel: '取消',
            confirmDelete: '刪除',
            discardTitle: '捨棄尚未同步的變更？',
            discardBody: '「{{name}}」已在其他裝置上刪除。這裡尚未同步的變更將會遺失，且無法撤回。',
            actionsMenu: '織圖操作',
            renameFailed: '無法重新命名織圖',
            deleteFailed: '無法刪除織圖',
            deletedElsewhere: '已在其他裝置上刪除',
            deletedElsewhereBody: '這裡有尚未同步的變更。',
            keepAsCopy: '另存為副本',
            discard: '捨棄',
            keepAsCopyFailed: '無法另存副本',
            discardFailed: '無法捨棄',
            openElsewhere: '這張織圖已在另一個分頁開啟——變更可能互相衝突',
            aiEditing: 'AI 編輯中…',
            updatedElsewhere: '這張織圖已在其他工作階段中更新',
            deletedTitle: '這張織圖已被刪除',
            deletedBody: '「{{name}}」已在其他裝置上刪除。這裡有尚未同步的變更。保留會將你的版本另存為新的織圖——原始織圖無法復原。',
            deletedKeep: '另存為新織圖',
            deletedDiscard: '捨棄並關閉',
            deletedBodyOpenCopy: '「{{name}}」已在另一台裝置上刪除。你可以將此裝置上的副本保留為新的織圖，但無法復原原始織圖。',
            syncConflictTitle: '離線期間的變更尚未同步',
            syncConflictBody: '此裝置離線期間，「{{name}}」已在另一台裝置上變更，因此此處的修改未儲存至該織圖。你可以將修改保留為新的織圖，或捨棄修改。',
            syncConflictKeep: '保留為新織圖',
            syncConflictDiscard: '捨棄我的變更',
            syncUnavailable: '目前無法即時同步此織圖，變更已儲存在此裝置',
            syncLoadFailed: '無法開啟此織圖，因為即時同步連線失敗。請檢查網路連線後再試一次。',
            archive: '封存',
            archiveDone: '已將「{{name}}」移至已封存',
            archiveFailed: '無法封存織圖',
            archivedTitle: '已封存',
            archivedEmpty: '目前沒有已封存的織圖。封存的織圖會以唯讀方式保留在這裡，並釋出一個有效織圖名額。',
            unarchive: '解除封存',
            unarchiveDone: '「{{name}}」已恢復為有效織圖',
            unarchiveFailed: '無法解除封存織圖',
            localOnly: '僅儲存在此裝置',
            localOnlyOverLimit: '超過免費方案額度，未儲存至你的帳號',
        },

        sharing: {
            menuItem: '分享',
            dialogTitle: '分享「{{name}}」',
            linkSection: '連結',
            createLink: '建立連結',
            linkActive: '任何擁有連結的人皆可檢視',
            copyLink: '複製連結',
            linkCopied: '已複製連結',
            rotateLink: '重設連結',
            revokeLink: '停用',
            linkHidden: '此連結建立於網址儲存功能之前，無法再次顯示 — 請重設連結以取得新網址。',
            peopleSection: '成員',
            emailPlaceholder: '電子郵件地址',
            invite: '邀請',
            pendingBadge: '待加入',
            invitePending: '該電子郵件尚未註冊 — 對方以此信箱登入後即可存取。',
            removePerson: '移除',
            allowCopy: '檢視者可以儲存副本',
            requestFailed: '分享請求失敗 — 請再試一次',
            loading: '正在載入分享設定…',
            viewOnly: '僅供檢視',
            saveCopy: '儲存副本',
            copySaved: '已儲存至你的織圖',
            copyForbidden: '擁有者已關閉此織圖的複製功能',
            copyFailed: '無法儲存副本 — 請再試一次',
            signInToCopy: '登入以儲存副本',
            linkUnavailable: '此分享連結已失效',
            sharedNotFound: '此共享織圖已失效',
            sharedWithMe: '與我共享',
            menuItemArchived: '分享',
            archivedNote: '此織圖已封存，因此只能縮減分享範圍：你可以停用連結、移除分享對象及關閉複製權限。若要進一步分享，請先解除封存。',
        },

        tryEditor: {
            defaultName: {
                crochet: '我的第一張鉤織圖',
                knitting: '我的第一張棒針圖',
            },
            signUpCta: '免費註冊',
            wall: {
                title: {
                    export: '免費註冊即可匯出',
                    share: '免費註冊即可分享',
                    newDiagram: '免費註冊即可建立更多圖表',
                },
                body: '你的作品會跟著你——在這裡完成的一切都會保留在你的帳號中。',
                cta: '免費註冊',
                dismiss: '繼續編輯',
            },
            claimed: '你的作品已加入你的帳號。',
        },

        billing: {
            limit: {
                title: '已達免費方案額度上限',
                body: '免費方案最多可保留 {{limit}} 份有效織圖。封存一份織圖即可騰出名額。已封存的織圖會以唯讀方式保留在帳號中，有名額時即可解除封存。',
                bodyNoLimit: '你已用完免費方案的有效織圖名額。封存一份織圖即可騰出名額。已封存的織圖會以唯讀方式保留在帳號中，有名額時即可解除封存。',
                archive: '封存',
                archiveNamed: '封存「{{name}}」',
                archiveFailed: '無法封存織圖，請再試一次。',
                loading: '正在載入你的織圖…',
                empty: '你的帳號中目前沒有可封存的織圖。僅儲存在此裝置的織圖，必須先上傳才能封存。',
                kind: {
                    crochet: '鉤針',
                    knitting: '棒針',
                },
                dismiss: '稍後再說',
                checkout: '升級至 Pro',
                proUnavailable: 'Pro 方案尚未開放。',
            },
            saveStatus: {
                overLimit: '已儲存在此裝置 — 超過免費方案額度',
                proRequired: '已儲存在此裝置 — 織圖文件需要 Pro 方案',
            },
            upgrade: {
                patternComposer: {
                    title: '織圖文件是 Pro 專屬功能',
                    body: '升級至 Pro 方案，即可建立和編輯織圖文件。你仍可以檢視及列印現有的織圖文件。',
                },
                dismiss: '稍後再說',
                checkout: '升級至 Pro',
                proUnavailable: 'Pro 方案尚未開放。',
            },
        },

        patterns: {
            title: '我的編織書寫',
            newDiagram: '新增編織書寫',
            untitled: '未命名',
            notFound: '找不到這份編織書寫',
            loadFailed: '無法載入這份編織書寫——內容未被更動',
            needsNewer: {
                title: '這份編織書寫需要較新版本的 {{appName}}',
                body: "它是由較新版本的應用程式儲存的。請重新載入以更新——您的編織書寫很安全，內容未被更動。",
                reload: '重新載入',
                back: '返回編織書寫列表',
            },
            createFailed: '無法建立新的編織書寫',
            saveStatus: {
                saving: '儲存中…',
                saved: '已儲存',
                error: '無法儲存',
                tooLarge: '檔案過大無法同步——僅儲存於此裝置',
            },
            save: '儲存',
            lastSavedToday: '今天 {{time}} 已儲存',
            lastSavedOn: '{{date}} {{time}} 已儲存',
            conflict: '已在其他裝置上變更——請重新載入以取得最新內容',
            offlineList: '目前離線——顯示此裝置上的副本',
            storageUnavailable: '無法使用本機儲存空間——變更將不會被儲存',
            listFailed: '無法載入你的編織書寫',
            empty: '還沒有任何編織書寫——建立第一份吧',
            renameLabel: '編織書寫名稱',
            rename: '重新命名',
            delete: '刪除',
            deleteTitle: '刪除編織書寫？',
            deleteBody: '「{{name}}」將被永久刪除。',
            cancel: '取消',
            confirmDelete: '刪除',
            discardTitle: '捨棄尚未同步的變更？',
            discardBody: '「{{name}}」已在其他裝置上刪除。這裡尚未同步的變更將會遺失，且無法撤回。',
            actionsMenu: '編織書寫動作',
            renameFailed: '無法重新命名這份編織書寫',
            deleteFailed: '無法刪除這份編織書寫',
            deletedElsewhere: '已在其他裝置上刪除',
            deletedElsewhereBody: '這裡有尚未同步的變更。',
            keepAsCopy: '另存為副本',
            discard: '捨棄',
            keepAsCopyFailed: '無法另存副本',
            discardFailed: '無法捨棄',
            localOnly: '僅儲存在此裝置',
            readOnlyBanner: '僅供檢視：編輯織圖文件需要 Pro 方案。你仍可列印這份文件。',
            readOnlyUpgrade: '升級方案',
        },

        info: {
            title: '關於',
            version: '版本',
            environment: '環境',
            build: '組建',
            licensesLink: '開放原始碼授權',
            offline: {
                installedVersion: '已安裝版本',
                installedOn: '安裝日期',
                licence: '授權 ID',
                checkForUpdates: '檢查更新',
                notInstalled: '此裝置上找不到安裝資訊。',
                backupNote: '儲存空間不足時，瀏覽器可能會清除此應用程式的資料。請備份您的作品。',
                backupLink: '全部匯出',
                pasteUpdateCode: '貼上更新碼',
                applyUpdateCode: '更新',
                notAnUpdateCode: '這不是更新碼。',
                updateCodeExpired: '此代碼已過期。請點選「檢查更新」以取得新的代碼。',
            },
        },

        // Pattern-language text (read with patternT): the running footer preset. Single braces are tokens, not i18next.
        headerFooter: {
            pageOfPages: '第 {page} 頁，共 {pages} 頁',
        },
        legend: {
            menuItem: '使用的針法',
            title: '使用的針法',
            description: '此織圖中使用的針法類型',
            empty: '尚無針目',
            increase: '加針',
            decrease: '減針',
            clusterStitch: '{{memberCount}}{{member}}玉針',
            clusterSpace: '{{memberCount}}{{member}}玉針（挑束）',
            popcornStitch: '{{memberCount}}{{member}}爆米花針',
            popcornSpace: '{{memberCount}}{{member}}爆米花針（挑束）',
        },

        diagramText: {
            menuItem: '產生文字',
            title: '圖樣文字',
            description: '從此圖表產生書面說明',
            empty: '尚無內容可描述',
            copy: '複製',
            row: '段',
            round: '圈',
            increase: '加針',
            decrease: '減針',
            inChSpace: '於 {{count}} 鎖針空隙',
            clusterLabel: '{{memberCount}}{{member}}玉針',
            clusterInSpace: '（挑束）',
            popcornLabel: '{{memberCount}}{{member}}爆米花針',
            popcornInSpace: '（挑束）',
            unassignedRound: '部分針目尚未指定圈數',
            orderUnverified: '順序未驗證',
            cross: '交叉{{stitch}}',
            turningChain: '起立針',
            turn: '翻面',
        },

        diagramRounds: {
            panelTitle: '段數',
            roundLabel: '第 {{n}} 段',
            unassigned: '未指定',
            stitchCount_one: '{{count}} 針',
            stitchCount_other: '{{count}} 針',
            showHalo: '強調此段',
            hideHalo: '取消強調此段',
            empty: '尚無段數',
            collapseAll: '全部收合',
            expandAll: '全部展開',
            expandSection: '展開區段',
            collapseSection: '收合區段',
        },

        viewer: {
            viewOnly: '僅供檢視',
            backToGallery: '回到我的織圖',
            storageUnavailable: '無法使用本機儲存空間 — 無法載入織圖',
            archivedTitle: '已封存：唯讀',
            archivedBody: '解除封存後即可再次編輯。',
        },

        crochetViewer: {
            inspectorTitle: '詳細資訊',
            typeLabel: '針法',
            roundLabel: '行/段',
            orderLabel: '順序',
            colorLabel: '顏色',
            multiSelected: '已選取 {{count}} 個針目',
        },

        licenses: {
            title: '開放原始碼授權',
            intro: '{{appName}} 使用了以下開放原始碼專案，感謝這些專案的作者。',
        },

        appearance: {
            title: '外觀',
            description: '選擇您偏好的色彩主題。',
            signInPrompt: '登入以管理您的設定。',
            loading: '載入設定中…',
            saveError: '儲存主題失敗，請再試一次。',
            theme: {
                label: '主題',
                light: '淺色',
                dark: '深色',
                system: '系統',
            },
        },

        settingsPage: {
            title: '設定',
            nav: {
                appearance: '外觀',
                crochet: '鉤針',
                account: '帳戶',
                billing: '帳務',
                offlineApp: '離線應用程式',
                yourData: '您的資料',
                hotkeys: '快捷鍵',
                info: '資訊',
                connectAi: '連接您的 AI',
            },
            language: {
                label: '語言',
            },
            account: {
                manageButton: '管理帳戶',
                signedOutPrompt: '登入以檢視您的帳戶。',
                noName: '未命名',
            },
            billing: {
                title: '帳務',
                intro: '訂閱即可解鎖完整編輯器。系統會將您帶往付款服務商完成結帳，之後再返回此頁。',
                signInPrompt: '登入以管理帳務。',
                checkoutButton: '繼續結帳',
                unavailable: '目前無法結帳。請稍後再試。',
                onPro: '你目前使用的是 Pro 方案。',
                foundingBadge: '創始設計師',
                foundingNote: '此方案為贈與方案，無需付款，也無需取消。',
                renewsOn: '將於 {{date}} 續訂。',
                endsOn: '存取權將於 {{date}} 結束。',
                lapsed: '您的訂閱已結束。重新訂閱即可再次解鎖完整編輯器。',
                manageButton: '管理訂閱',
                loadError: '無法載入您的帳務詳細資料。請稍後再試。',
                portalError: '無法開啟訂閱管理頁面。請再試一次。',
                cancelButton: '取消訂閱',
                resumeButton: '恢復訂閱',
                cancelConfirmTitle: '要取消訂閱嗎？',
                cancelConfirmBody: '訂閱將不再續訂。您在 {{date}} 前仍保有存取權，在此之前隨時可以恢復訂閱。',
                cancelConfirmBodyNoDate: '訂閱將不再續訂。在訂閱結束前，您隨時可以恢復。',
                cancelConfirmKeep: '保留訂閱',
                cancelConfirmAction: '取消訂閱',
                cancelled: '已取消您的訂閱。',
                resumed: '已恢復您的訂閱。',
                cancelError: '無法取消您的訂閱。請再試一次。',
                resumeError: '無法恢復您的訂閱。請再試一次。',
            },
            offlineApp: {
                title: '離線應用程式',
                intro: '在此裝置上安裝 {{appName}}，沒有網路連線時也能繼續工作。',
                getButton: '取得離線應用程式',
                opening: '正在開啟…',
                popupBlocked: '您的瀏覽器已阻擋在新分頁中開啟安裝頁面。',
                openInstallPage: '開啟安裝頁面',
                dataCopyNote: '在 Chrome 和 Edge 中，安裝時會一併複製您的織圖與織圖文件。其他瀏覽器請前往設定 → 您的資料。',
                copying: '正在將您的作品複製到離線應用程式… {{done}} / {{total}}',
                copied: '已複製',
                copyFailed: '無法複製。請使用「全部匯出」，再於離線應用程式中「匯入」。',
                trial: '離線應用程式包含於付費方案中。',
                trialConverts: '試用期轉為付費方案後即可使用。',
                subscribe: '訂閱以取得離線應用程式',
                signInPrompt: '登入以取得離線應用程式。',
                loadError: '無法載入您的方案詳細資料。請稍後再試。',
                tokenError: {
                    not_entitled: '您的帳戶不包含離線應用程式。訂閱即可取得。',
                    trial_not_eligible: '離線應用程式包含於付費方案中。',
                    rate_limited: '嘗試次數過多。請稍候片刻再試一次。',
                    unavailable: '目前無法使用離線應用程式。請稍後再試。',
                    failed: '無法開啟安裝頁面。請再試一次。',
                },
            },
            yourData: {
                title: '您的資料',
                intro: '將您所有的織圖與織圖文件儲存成一個檔案，或從檔案帶入作品。匯入絕不會覆寫任何內容。',
                exportButton: '全部匯出',
                importButton: '匯入…',
                exporting: '正在匯出 {{done}} / {{total}}…',
                checking: '正在檢查 {{done}} / {{total}}…',
                importing: '正在匯入 {{done}} / {{total}}…',
                importedName: '{{name}}（已匯入）',
                count: {
                    diagram_one: '{{count}} 張織圖',
                    diagram_other: '{{count}} 張織圖',
                    pattern_one: '{{count}} 份織圖文件',
                    pattern_other: '{{count}} 份織圖文件',
                },
                export: {
                    done: '已匯出 {{diagrams}}與 {{patterns}}。',
                    unreadable: '有 {{count}} 個項目無法讀取。',
                    imagesMissing_one: '有 {{count}} 張圖片無法納入。',
                    imagesMissing_other: '有 {{count}} 張圖片無法納入。',
                },
                import: {
                    done: '已匯入 {{diagrams}}與 {{patterns}}。',
                    doneWithCopies_one: '已匯入 {{diagrams}}與 {{patterns}}（其中 {{count}} 個以副本形式匯入）。',
                    doneWithCopies_other: '已匯入 {{diagrams}}與 {{patterns}}（其中 {{count}} 個以副本形式匯入）。',
                    archived_one: '{{count}} 份織圖因免費方案額度已滿而封存。',
                    archived_other: '{{count}} 份織圖因免費方案額度已滿而封存。',
                    alreadyHere_one: '有 {{count}} 個項目已經存在。',
                    alreadyHere_other: '有 {{count}} 個項目已經存在。',
                    needsNewer_one: '有 {{count}} 個項目需要較新版本的 {{appName}}。',
                    needsNewer_other: '有 {{count}} 個項目需要較新版本的 {{appName}}。',
                    patternsSkipped_one: '已略過 {{count}} 份織圖文件：此功能需要 Pro 方案。',
                    patternsSkipped_other: '已略過 {{count}} 份織圖文件：此功能需要 Pro 方案。',
                    unreadable: '有 {{count}} 個項目無法讀取。',
                    tooLarge_one: '有 {{count}} 個項目過大，無法同步。',
                    tooLarge_other: '有 {{count}} 個項目過大，無法同步。',
                    failed: '有 {{count}} 個項目無法儲存。',
                    imagesSkipped_one: '有 {{count}} 張圖片無法匯入。',
                    imagesSkipped_other: '有 {{count}} 張圖片無法匯入。',
                },
                notABundle: '這不是 {{appName}} 檔案。',
                tooNew: '此檔案是以較新版本的 {{appName}} 建立的。請更新後再開啟。',
                unreachable: '無法連線至 {{appName}}。請檢查您的網路連線，然後再試一次。',
                unavailable: '此瀏覽器無法使用儲存空間。',
                exportFailed: '無法匯出您的作品。請再試一次。',
                importFailed: '無法匯入此檔案。請再試一次。',
            },
            crochet: {
                defaultSizingTab: '預設尺寸',
                description: '每種針法的預設尺寸。僅套用於新建立的織圖——現有織圖仍保留建立時的預設值。',
                saveError: '儲存預設尺寸失敗，請再試一次。',
                signInPrompt: '登入以編輯預設尺寸。',
                loading: '正在載入預設尺寸…',
                typeLabel: '針法類型',
                auto: '自動',
                resetType: '重設此針法',
                resetAll: '全部重設',
                barLabel: '第 {{n}} 桿',
                capAngleFollowingHint: '當「跟隨參考線方向」開啟時停用。',
                fields: {
                    'top-cap': '頂端長度',
                    crossbar: '橫桿長度',
                    crossbar2: '橫桿 2 長度',
                    crossbar3: '橫桿 3 長度',
                    hook: '鉤環大小',
                    width: '寬度',
                    widthScale: '寬度',
                    capAngle: '頂端角度',
                    crossbarAngle: '橫桿角度',
                    crossbarPos: '橫桿位置',
                    bodyGapTop: '頂部間距',
                    bodyGapBase: '底部間距',
                    followTangent: '跟隨引導方向',
                    cap: '頂端長度',
                },
                strokeTab: '線條',
                strokeDescription: '針法符號的線條寬度與線端樣式。僅套用於新建立的織圖——現有織圖保留各自的設定。',
                strokeSaveError: '儲存線條預設值失敗，請再試一次。',
                strokeSignInPrompt: '登入以編輯線條預設值。',
                strokeLoading: '正在載入線條預設值…',
            },
            connectAi: {
                title: '連接您的 AI',
                intro:
                    '讓 Claude 或 ChatGPT 與您一起建立織圖，它會透過您使用的相同工具，一次一個步驟地操作。您只需要下方的端點——以您的 {{appName}} 帳號登入即可，不必複製任何用戶端 ID 或 API 金鑰。',
                supportedClients:
                    '目前可連接 claude.ai（包含 Claude 桌面應用程式）與 ChatGPT。尚不支援 Claude Code 及其他 AI 應用程式。',
                endpointLabel: 'MCP 端點',
                copy: '複製',
                copied: '已複製到剪貼簿',
                copyError: '無法複製——請選取文字後手動複製。',
                claudeAppTitle: 'claude.ai 與 Claude 桌面應用程式',
                claudeAppStepOpen: '前往設定 → 連接器，新增自訂連接器。',
                claudeAppStepUrl:
                    '將名稱設為 {{appName}}，並將上方的 MCP 端點貼到 URL 欄位。不需要 OAuth 用戶端 ID 或密鑰——Claude 會自動識別自己的身分。',
                claudeAppStepConnect: '點選連接，並以您的 {{appName}} 帳號登入。',
                chatgptTitle: 'ChatGPT',
                chatgptStepDevMode: '在 ChatGPT 的設定中開啟開發者模式（Developer mode），此功能僅限付費方案使用。',
                chatgptStepCreate:
                    '建立新的應用程式，將名稱設為 {{appName}}，並將上方的 MCP 端點貼到 URL 欄位。驗證方式選擇 OAuth——不需要用戶端 ID 或密鑰。',
                chatgptStepConnect: '連接該應用程式，並以您的 {{appName}} 帳號登入。',
                chatgptStepUse: '在對話中，從「+」選單加入 {{appName}}，讓 ChatGPT 可以使用它。',
                openEditorNote: '請先在編輯器中開啟這張織圖——AI 只能編輯目前開啟中的織圖。',
                reconnectNote: '之前曾使用用戶端 ID 設定 {{appName}} 嗎？請移除該連線，再依照上方步驟重新新增——現在已不再使用用戶端 ID。',
                privacyNote: 'AI 會以您的身分操作，且僅限於您自己的織圖，絕不會觸碰其他人的作品。',
                signInPrompt: '登入以連接 AI 助手。',
            },
        },

        hotkeysReference: {
            title: '快捷鍵',
            description: '目前使用中的鍵盤快捷鍵，依編輯器分類。',
            groups: {
                global: '一般',
                crochet: '鉤針編輯器',
                annotation: '註記圖層',
                grid: '棒針編輯器',
                composer: '織圖文件編輯器',
            },
            keys: {
                space: 'Space',
                drag: '拖曳',
                scroll: '滾動',
                ctrl: 'Ctrl',
                enter: 'Enter',
                esc: 'Esc',
                delete: 'Delete',
                backspace: 'Backspace',
                hold: '按住',
                doubleClick: '雙擊',
                arrows: '↑ ↓ ← →',
                shift: 'Shift',
                dragCorner: '拖曳角落控制點',
                dragEdge: '拖曳邊緣控制點',
                dragHandle: '拖曳旋轉控制點',
                dragDraw: '使用「線條」工具按住拖曳',
                dragAnchor: '拖曳錨點控制點',
                cmd: 'Cmd',
                pinch: '雙指縮放',
                middleDrag: '中鍵拖曳',
                pageUp: 'Page Up',
                pageDown: 'Page Down',
                click: '點按',
                dragBackground: '在頁面空白處拖曳',
            },
            global: {
                save: '儲存',
                commandPalette: '開啟指令面板',
                pan: '平移畫布',
                zoom: '縮放',
                layerStitch: '切換到針目圖層',
                layerAnnotation: '切換到註記圖層',
            },
            crochet: {
                undo: '復原',
                redo: '重做',
                copy: '複製',
                paste: '貼上至游標位置',
                pasteWithStitches: '貼上參考線與貼齊其上的針目',
                pasteWithStructure: '貼上參考線與整組針目結構',
                duplicate: '再製',
                delete: '刪除選取項目',
                grab: '移動選取項目（抓取）',
                grabAxis: '鎖定抓取的 X／Y 軸向',
                slide: '沿參考線滑動選取項目',
                slideRigid: '整體滑動選取項目',
                extend: '擴大選取範圍',
                extendCoarse: '擴大選取範圍（粗略）',
                shrink: '縮小選取範圍',
                shrinkCoarse: '縮小選取範圍（粗略）',
                nudge: '微移選取項目',
                nudgeCoarse: '大幅微移選取項目',
                fillGuide: '調整選取項目寬度以填滿參考線',
                alignToNormal: '將選取項目對齊法線方向',
                alignRadially: '將選取項目徑向對齊',
                flipHorizontal: '水平翻轉選取項目',
                flipVertical: '垂直翻轉選取項目',
                toolToggle: '切換針目／參考線工具',
                handleType: '循環切換貝茲控制點類型',
                link: '切換連結模式',
                snap: '切換貼齊格線',
                scopeBases: '僅選取底部',
                scopeTops: '僅選取頂部',
                pieMenu: '開啟圓形選單',
                quickAccess: '開啟快速存取',
                commit: '確認待處理操作',
                cancel: '取消目前操作',
                editGuide: '編輯參考線形狀（參考線工具）',
                exitGuideEdit: '結束編輯參考線形狀',
                propertiesPanel: '顯示／隱藏屬性面板',
            },
            annotation: {
                delete: '刪除所選註記',
                duplicate: '建立所選註記的副本',
                copy: '複製所選註記',
                paste: '在指標位置貼上註記',
                selectAll: '選取所有註記',
                nudge: '微移所選註記',
                nudgeCoarse: '大幅微移所選註記',
                cancel: '取消放置或操作',
                scale: '調整所選註記大小',
                stretch: '沿單一軸向拉伸所選註記',
                rotate: '旋轉所選註記',
                drawLine: '繪製連接線',
                moveAnchor: '移動線條錨點',
                editCurve: '編輯形狀或標籤（曲線、圓形、弧線、文字）',
                cycleHandle: '循環切換控制點類型',
            },
            grid: {
                undo: '復原',
                redo: '重做',
                copy: '複製',
                paste: '貼上',
                modeToggle: '切換針目／格子模式',
                grab: '移動選取項目（抓取）',
                pieMenu: '開啟圓形選單',
                cancel: '取消目前操作',
            },
            composer: {
                deleteElement: '刪除選取項目',
                deselect: '取消選取',
                dragWithoutSnap: '拖曳時不貼齊',
                toggleSnap: '切換貼齊',
                bold: '粗體（文字）',
                italic: '斜體（文字）',
                underline: '底線（文字）',
                undo: '復原',
                redo: '重做',
                textUndo: '輸入時復原',
                textRedo: '輸入時重做',
                zoomIn: '放大',
                zoomOut: '縮小',
                fitPage: '整頁顯示',
                zoom: '縮放',
                pan: '平移畫布',
                panScreen: '捲動一個畫面',
                panArrows: '捲動（未選取任何物件時）',
                nudge: '微移選取項目 1 像素',
                nudgeLarge: '微移選取項目 10 像素',
                bringForward: '上移一層',
                sendBackward: '下移一層',
                bringToFront: '移到最前',
                sendToBack: '移到最後',
                selectAll: '全選此頁的元素',
                addToSelection: '加入或移出選取範圍',
                marquee: '框選範圍',
            },
        },

        commandPalette: {
            placeholder: '搜尋編輯器功能…',
            empty: '沒有符合的功能',
            howTo: '使用方式',
            descriptions: {
                global: {
                    pan: '按住空白鍵拖曳，或使用捲動，即可在畫布上移動。',
                    zoom: '按住 Ctrl 並捲動即可放大縮小。',
                },
                crochet: {
                    paste: '先複製，再按貼上快捷鍵——針目會放置在滑鼠游標處。',
                    pasteWithStitches: '在參考線工具中複製參考線後，這個快捷鍵會連同貼齊在上面的針目一起貼上。',
                    pasteWithStructure: '與「貼上並帶上貼齊的針目」相同，但還會一併帶上疊在那些針目上方的各段。',
                    grab: '選取針目後按 G，移動滑鼠，再點擊或再按一次 G 放下。',
                    grabAxis: '使用 G 抓取時，按 X 可僅水平移動，按 Y 可僅垂直移動；再次按相同按鍵即可解除鎖定。綠色（X）或紅色（Y）線條會顯示鎖定的軸向。',
                    slide: '選取參考線上的針目後按 C 沿線滑動；點擊即可放下。',
                    slideRigid: '與滑動相同，但 Shift+C 會在滑動時保持針目間距固定。',
                    extend: '有選取時按 ]，沿參考線延伸一針。',
                    extendCoarse: 'Shift+] 以較大幅度延伸選取範圍。',
                    shrink: '有選取時按 [ 縮減一針。',
                    shrinkCoarse: 'Shift+[ 以較大幅度縮減選取範圍。',
                    nudge:
                        '按方向鍵可將所選針目（或使用參考線工具時的所選參考線）移動一個像素。貼齊參考線或附著於其他針目的控制點會維持原位——若要微移這類針目，請只選取其中可自由移動的控制點。',
                    nudgeCoarse: 'Shift + 方向鍵可將選取項目移動十個像素。',
                    scopeBases: '按住 B 點擊，只選取針目的底部。',
                    scopeTops: '按住 T 點擊，只選取針目的頂部。',
                    pieMenu: '按住 S 在游標處開啟圓形選單，移到選項上放開。',
                    quickAccess: '按 W 鍵，可在游標位置開啟快速存取選單。若要新增操作，請在針目的右鍵選單或此搜尋結果中，對該操作按滑鼠右鍵。',
                    commit: '按 Enter 確認待定的加針、減針或參考線編輯。',
                    cancel: '按 Esc 取消目前待定的操作或選取流程。',
                    editGuide: '使用參考線工具時，選取一條參考線後按 Enter（或雙擊）即可編輯其形狀。',
                    exitGuideEdit: '按 Esc 離開參考線形狀編輯。',
                },
                annotation: {
                    paste: '在註記圖層中，先複製一個記號，再按貼上快捷鍵，記號就會出現在滑鼠指標的位置。',
                    nudge: '在註記圖層選取記號後，按方向鍵可將它移動一個像素。',
                    nudgeCoarse: 'Shift + 方向鍵可將所選記號移動十個像素。',
                    cancel: '按 Esc 可取消已準備放置的記號，或中止拖曳／旋轉。',
                    scale: '在註記圖層選取記號並拖曳四個角落控制點之一；記號會以中心為基準等比例縮放。',
                    stretch: '拖曳四個邊緣控制點之一，即可只沿該軸向拉伸記號；拖曳角落則會維持比例。',
                    rotate: '選取記號並拖曳其前方的圓形控制點，將它轉向新的方向。',
                    drawLine: '在左側欄選擇「線條」，接著在畫布上按下並拖曳到另一端；端點靠近針目時會貼齊並跟隨該針目。',
                    moveAnchor: '選取線條並拖曳其中一個圓形錨點控制點；在針目上放開即可附著於該針目。',
                    editCurve:
                        '選取曲線、圓形、弧線或文字標籤後，按 Enter（或連按兩下，或使用檢查器中的「編輯形狀」按鈕）以顯示控制點；若為文字標籤，則會開始輸入。',
                    cycleHandle: '編輯曲線時，選取一個控制點後按 T，可在「對齊」、「向量」和「自由」三種類型間循環切換。',
                },
                grid: {
                    grab: '選取格子後按 G，移動滑鼠，再點擊或再按一次 G 放下。',
                    pieMenu: '按住 S 在游標處開啟圓形選單，移至選項上放開。',
                    cancel: '按 Esc 取消目前操作。',
                },
            },
        },

        consent: {
            banner: {
                title: '我們使用 Cookie',
                description: '{{appName}} 使用分析 Cookie 來瞭解應用程式的使用情形並加以改進。您可以全部接受、拒絕，或選擇允許的類別。',
                acceptAll: '全部接受',
                rejectAll: '全部拒絕',
                customize: '自訂',
                save: '儲存選擇',
                privacyLink: '隱私權與 Cookie',
            },
            categories: {
                analytics: {
                    label: '分析',
                    description: '協助我們改進應用程式的使用事件與自動互動擷取。',
                },
                sessionReplay: {
                    label: '工作階段重播',
                    description: '記錄匿名化的工作階段以便診斷問題，比分析更為詳細。',
                },
                errorMonitoring: {
                    label: '錯誤監控',
                    description: '將當機報告與效能資料傳送給 Sentry，以便我們找出並修正問題。',
                },
            },
            settings: {
                navLabel: '隱私權與 Cookie',
                title: '隱私權與 Cookie',
                description: '管理 {{appName}} 可使用的分析 Cookie。儲存後將重新載入頁面以套用您的選擇。',
                viewPolicy: '查看隱私權與 Cookie 頁面',
            },
            privacyPage: {
                title: '隱私權與 Cookie',
                intro:
                    '{{appName}} 基於以下目的使用 Cookie 與類似技術（包含瀏覽器的本機儲存空間）。嚴格必要項目一律啟用；分析與工作階段重播僅在您同意時執行，且可隨時變更。',
                manage: '管理 Cookie 偏好設定',
                policy: {
                    updated: '最後更新：{{date}}',
                    whoWeAre: {
                        p1:
                            '{{appName}} 是由 Kinnet Studio（「我們」）營運的編織與鉤織圖樣設計應用程式。本隱私權政策說明您使用 {{appName}} 時我們收集哪些個人資料、如何使用、與誰共享，以及您擁有的選擇。本政策以英文版本為準。',
                        contact: '隱私權相關聯絡方式：',
                    },
                    dataWeCollect: {
                        title: '我們收集的資料',
                        p1:
                            '帳戶資訊。當您建立帳戶時，我們會透過驗證服務商 Clerk 取得您的電子郵件地址、顯示名稱與大頭貼。若您使用 Google 等第三方服務登入，該服務商會將這些基本個人資料提供給我們；我們永遠不會取得您在該服務商的密碼。',
                        p2: '您的內容。您建立的圖樣、圖表與織圖會儲存在我們的伺服器上，以便在您的裝置間同步，並在您選擇時與他人分享。',
                        p3:
                            '使用與診斷資料（選擇性）。在您同意的情況下，我們會收集分析事件、匿名化的工作階段重播與錯誤報告，以瞭解應用程式的使用情形並修正問題。這些預設為關閉，可透過 Cookie 橫幅或設定頁控制。',
                        p4: '裝置偏好。語言、字型大小、針法顏色等設定僅儲存在您的瀏覽器本機，不會傳送給我們。',
                    },
                    googleUserData: {
                        title: 'Google 使用者資料',
                        p1:
                            '若您使用 Google 登入，{{appName}} 僅會透過驗證服務商 Clerk 取得您的基本 Google 個人資料——姓名、電子郵件地址與大頭貼。我們不會要求存取任何其他 Google 服務或資料（例如 Gmail、雲端硬碟或聯絡人）。',
                        p2: '我們僅將這些資訊用於建立與保護您的 {{appName}} 帳戶、在應用程式中識別您，以及與您就本服務進行聯繫。',
                        p3:
                            '我們不會出售 Google 使用者資料、將其用於廣告，或與下方所列服務商以外的任何第三方共享；這些服務商僅代表我們處理資料以營運 {{appName}}。',
                    },
                    howWeUse: {
                        title: '我們如何使用您的資料',
                        p1: '我們使用您的資料來提供 {{appName}}：驗證您的身分、儲存並同步您的圖樣，以及提供您選擇使用的分享功能。',
                        p2: '在您同意的情況下，我們也會使用彙總的使用資料與錯誤報告來改進應用程式。我們不會出售您的個人資料，也不會將其用於第三方廣告。',
                    },
                    processors: {
                        title: '服務提供者',
                        intro: '我們依靠以下服務提供者營運 {{appName}}。各服務商僅代表我們、且僅在提供其服務所需的範圍內處理資料：',
                        items: {
                            clerk: 'Clerk——驗證與帳戶管理（電子郵件、姓名、大頭貼、登入狀態）。',
                            cloudflare: 'Cloudflare——應用程式代管與您同步內容的儲存。',
                            statsig: 'Statsig——產品分析與工作階段重播；僅在您同意時啟用。',
                            sentry: 'Sentry——當機與錯誤報告；僅在您同意時啟用。',
                            userback: 'Userback——意見回饋收集；僅在您開啟意見回饋表單時載入。',
                            google: 'Google——僅用於登入（若您選擇使用 Google 登入）。',
                        },
                    },
                    retention: {
                        title: '資料保留與刪除',
                        p1:
                            '只要您的帳戶存在，我們就會保留您的帳戶資料與內容。當您刪除帳戶時，您的帳戶資料與同步內容會從我們的系統中刪除；備份中的殘留副本會依正常輪替排程移除。',
                        p2: '您可以隨時透過上方電子郵件地址聯絡我們，要求刪除您的帳戶與資料，或索取我們所持有關於您的資料副本。',
                    },
                    cookies: {
                        title: 'Cookie 與本機儲存空間',
                    },
                    yourRights: {
                        title: '您的權利與選擇',
                        p1:
                            '您可以隨時使用上方或設定頁中的「管理 Cookie 偏好設定」按鈕，撤回或變更您對分析、工作階段重播與錯誤監控的同意。撤回同意後即停止後續收集。',
                        p2: '依據您所在地區的法律，您可能還擁有存取、更正、匯出或刪除個人資料的權利。請透過上方電子郵件地址聯絡我們，我們將依法處理您的請求。',
                    },
                    changes: {
                        title: '本政策的變更',
                        p1: '隨著 {{appName}} 的發展，我們可能會更新本政策。重大變更會在應用程式內公告，上方的「最後更新」日期永遠反映目前版本。',
                    },
                },
                table: {
                    name: '名稱',
                    purpose: '用途',
                    storage: '儲存方式',
                },
                storageType: {
                    cookie: 'Cookie',
                    local: '本機儲存空間',
                    network: '傳送至 Sentry',
                },
                cat: {
                    necessary: {
                        title: '嚴格必要',
                        desc: '登入及維持應用程式運作所需，由我們的驗證服務商（Clerk）提供。無法關閉。',
                    },
                    functional: {
                        title: '功能偏好',
                        desc: '在此裝置上記住您的設定。僅限第一方，不進行追蹤。',
                    },
                    analytics: {
                        title: '分析',
                        desc: '協助我們瞭解使用情形並改進應用程式，透過分析服務商（Statsig）。僅在您同意時啟用。',
                    },
                    replay: {
                        title: '工作階段重播',
                        desc: '記錄匿名化的工作階段以診斷問題，透過 Statsig。僅在您同意時啟用。',
                    },
                    errorMonitoring: {
                        title: '錯誤監控',
                        desc:
                            '擷取當機報告與效能資料以協助我們修正問題，透過監控服務商（Sentry）。不會設定持續性 Cookie — 資料透過網路傳送。僅在您同意時啟用。',
                    },
                },
                purpose: {
                    clerkSession: '保持您的登入狀態（驗證）。',
                    clerkUat: '追蹤登入狀態以進行頁面路由。',
                    consent: '記住您的 Cookie 選擇。',
                    lang: '您的語言偏好。',
                    fontSize: '您的介面字型大小偏好。',
                    bentoRadius: '您的編輯器面板圓角偏好。',
                    cursor: '是否啟用自訂游標。',
                    colors: '您儲存的自訂針法顏色。',
                    featureGates: '記住哪些應用程式功能已開啟，避免載入時閃爍。',
                    statsigStable: '用於分析的匿名裝置識別碼。',
                    statsigSession: '將分析事件歸入一個工作階段。',
                    statsigCache: '排入佇列的分析事件與快取的設定。',
                    replay: '緩衝匿名化的工作階段重播記錄。',
                    sentryDiagnostics: '傳送至 Sentry 的當機報告與效能／效能分析資料。',
                },
            },
        },

        authFooter: {
            privacy: '隱私權政策',
            terms: '服務條款',
            licenses: '授權條款',
        },

        authSiteLinks: {
            label: '{{appName}} 網站',
            prompt: '第一次使用 {{appName}}？',
            landing: '看看有哪些功能',
            blog: '閱讀部落格',
        },

        unproofreadTranslationNotice: {
            message: '日文翻譯尚未經過校對，請斟酌使用。我們正在進行校對。',
            close: '關閉',
            languageOptionHint: '翻譯尚未校對',
        },

        whatsNew: {
            title: '新功能',
            description: '{{appName}} 的最新改進。',
            unreadHint: '有新的更新',
            menuLabelUnread: '開啟導覽選單（有新的更新）',
            titleUnread: '新功能（有新的更新）',
            openAsPage: '以頁面開啟',
            empty: '目前還沒有更新說明。',
            loading: '載入中…',
            loadError: '無法載入這些更新說明。',
            retry: '重試',
            languageFallback: '目前還沒有{{language}}版本，以下為英文。',
        },

        terms: {
            title: '服務條款',
            updated: '最後更新：{{date}}',
            intro: {
                p1:
                    '本服務條款是您與 {{appName}}（一款編織與鉤織圖樣設計應用程式）的營運者 Kinnet Studio（「我們」）之間的協議。建立帳戶或使用 {{appName}} 即表示您同意本條款；若您不同意，請勿使用本服務。本條款以英文版本為準。',
                contact: '關於本條款的問題：',
            },
            sections: {
                account: {
                    title: '您的帳戶',
                    p1: '您透過我們的驗證服務商 Clerk 登入 {{appName}}。請妥善保管您的登入憑證：您須對帳戶下發生的活動負責。',
                    p2: '您必須年滿 13 歲才能使用 {{appName}}。',
                },
                yourContent: {
                    title: '您的內容',
                    p1: '您建立的圖樣、圖表與織圖屬於您。本條款不會將您內容的任何所有權轉讓給我們。',
                    p2:
                        '為了營運 {{appName}}，您授予我們一項全球性、非專屬的授權，允許我們代管、儲存、重製並展示您的內容——僅限於提供本服務所需，包括跨裝置同步及您選擇啟用的分享功能。',
                },
                acceptableUse: {
                    title: '可接受的使用',
                    p1: '請僅將 {{appName}} 用於合法目的。請勿上傳侵害他人權利的內容，也不得利用本服務騷擾或傷害任何人。',
                    p2: '請勿干擾或破壞本服務、嘗試存取不屬於您的帳戶或資料，或以我們提供的介面以外的自動化方式抓取或存取本服務。',
                },
                service: {
                    title: '本服務',
                    p1: '隨著服務的發展，我們可能新增、變更或移除 {{appName}} 的功能。',
                    p2: '我們可能隨時修改、暫停或終止本服務的全部或部分。',
                },
                ip: {
                    title: '我們的智慧財產',
                    p1: '{{appName}} 應用程式及其設計、名稱與品牌屬於我們所有。除使用本服務外，本條款不授予您任何相關權利。您的內容仍屬於您（見「您的內容」）。',
                },
                termination: {
                    title: '終止與轉讓',
                    p1: '您可以隨時停止使用 {{appName}} 並刪除帳戶。資料刪除依我們的隱私權政策辦理。',
                    p2: '若您違反本條款，我們可能暫停或終止您的帳戶。',
                    p3: '我們可能因組織重整或服務移轉，將本條款及其所建立的協議轉讓給繼受或關聯實體。您在本條款下的權利屬於您個人，不得轉讓。',
                },
                disclaimers: {
                    title: '免責聲明',
                    p1: '在法律允許的最大範圍內，{{appName}} 依「現狀」及「現有」提供，不附任何明示或默示的保證——包括特定目的適用性，以及不中斷或無錯誤運作。',
                },
                liability: {
                    title: '責任限制',
                    p1:
                        '在法律允許的最大範圍內，我們就因本服務引起或與其相關的任何請求所負的全部責任，以請求發生前十二個月內您為本服務支付給我們的金額為上限。我們不對間接、附帶或衍生性損害（包括資料遺失）負責。',
                },
                law: {
                    title: '準據法',
                    p1: '本條款以中華民國（臺灣）法律為準據法，因本條款或您使用 {{appName}} 所生的任何爭議，應由臺灣法院管轄。',
                },
                changes: {
                    title: '本條款的變更',
                    p1:
                        '隨著 {{appName}} 的發展，我們可能更新本條款。上方的「最後更新」日期永遠反映目前版本——請不時查看本頁面。變更生效後繼續使用本服務，即表示您接受更新後的條款。',
                },
            },
        },

        waitlist: {
            heading: '{{appName}} 採邀請制',
            subtext: '加入候補名單，有名額時我們會以電子郵件通知您。',
        },

        contextMenu: {
            atCell: '第 {{row}} 行、第 {{col}} 列',
            selectionArea: '選取：{{rowCount}} 行 × {{colCount}} 列（第 {{r1}}–{{r2}} 行、第 {{c1}}–{{c2}} 列）',
            copyPattern: '複製圖形',
            pastePattern: '貼上圖形',
            clipboardLoading: '剪貼簿：檢查中…',
            clipboardEmpty: '剪貼簿：空白',
            clipboardHasPattern: '剪貼簿：有編輯器圖形',
            clipboardHasOther: '剪貼簿：有其他文字',
            clipboardUnavailable: '剪貼簿：無法讀取（權限或瀏覽器）',
            copyReplacesClipboard: '複製會取代目前剪貼簿內容。',
            fillRange: '以目前針跡填滿選取範圍',
            fillColorRange: '以目前顏色填滿選取範圍',
            clearRange: '清除選取範圍內的格線',
            placeCellHere: '在此放置格子',
            startNewPieceHere: '在此開始新織片',
            removeCellHere: '移除格子',
        },

        // Toolbar
        toolbar: {
            placeTool: '放置',
            placeToolDescription: '在格線上放針跡',
            selectTool: '選取',
            selectToolDescription: '選取格線。拖曳框選；按住 Shift 再點可從錨點擴大範圍',
            prependRow: '往上新增 {{count}} 行',
            appendRow: '往下新增 {{count}} 行',
            removeFirstRow: '移除前 {{count}} 行',
            removeLastRow: '移除最後 {{count}} 行',
            prependColumn: '在左側新增 {{count}} 列',
            appendColumn: '在右側新增 {{count}} 列',
            removeFirstColumn: '移除最前 {{count}} 列',
            removeLastColumn: '移除最後 {{count}} 列',
            stitchPicker: '選擇針法',
            eraseTool: '擦除',
            eraseToolDescription: '從格線上擦除針跡',
            stitchColor: '針跡顏色',
            stitchColorStandard: '標準',
            stitchColorCustomHint: '自訂（右鍵色票可變更）',
            stitchColorCustomSlot: '自訂色票 {{n}}',
            stitchColorEditingSlot: '編輯第 {{n}} 格',
            stitchColorBack: '返回色票',
            stitchColorHue: '色相',
            stitchColorSaturation: '飽和度與明度',
            stitchColorHex: '十六進位色碼',
            stitchMode: '針目模式',
            cellMode: '格子模式',
            stitchModeShort: '針目',
            cellModeShort: '格子',
            cellModeDescription: '塑形：新增或移除圖表格子',
            stitchModeDescription: '在既有格子中編輯針目',
            inputMode: {
                mouse: '滑鼠',
                trackpad: '觸控板',
                switchToTrackpad: '目前以鍵盤與滑鼠進行平移與縮放。點擊以切換為觸控板。',
                switchToMouse: '目前以觸控板進行平移與縮放。點擊以切換為鍵盤與滑鼠。',
            },
        },

        export: {
            button: '匯出範圍',
            panelTitle: '匯出選項',
            dragHint: '拖曳出要匯出的範圍，或按 Esc 取消',
            includeGrid: '背景格線',
            includeGuides: '參考線',
            includeLabels: '行列標籤',
            includeLabelsCrochet: '段數／順序標籤',
            transparent: '透明背景',
            quality: '畫質',
            cancel: '取消',
            download: '下載 PNG',
            exporting: '匯出中…',
            failed: '匯出失敗，請再試一次。',
        },

        diagramEmbed: {
            title: '插入織圖',
            frameTitle: '織圖範圍選取',
            loading: '正在載入織圖…',
            noDiagrams: '尚未儲存任何織圖。',
            kindCrochet: '鉤針',
            kindKnitting: '棒針',
            use: '使用這個範圍',
            refresh: '從織圖更新',
            tooLarge: '選取範圍太大，無法插入。請降低畫質或縮小範圍。',
            renderFailed: '無法匯出織圖，請再試一次。',
            insertFailed: '無法插入織圖，請再試一次。',
            emptyDiagram: '這張織圖是空的 — 沒有可插入的內容。',
            diagramUnavailable: '這張織圖已無法使用。',
            frameTimeout: '織圖檢視器載入失敗，請再試一次。',
        },

        strokeStyle: {
            label: '線條',
            width: '寬度',
            cap: {
                label: '線端',
                round: '圓角',
                square: '方角',
                butt: '平角',
            },
            inherited: '織圖預設',
            mixed: '多種',
            resetToDiagram: '重設為織圖設定',
            resetToFactory: '重設',
            widthValue: '{{value}}×',
        },

        crochetInspector: {
            ringHeading: '環',
            lineGuideHeading: '直線參考線',
            circleGuideHeading: '圓形參考線',
            centerSymbolLabel: '中心符號',
            centerSymbol: {
                none: '無',
                'magic-ring': '魔術環',
                wa: 'わ',
            },
            bezierGuideHeading: '貝茲曲線參考線',
            bezierClose: '閉合曲線',
            bezierOpen: '開放曲線',
            bezierAddAnchor: '新增錨點',
            bezierRemoveAnchor: '移除錨點',
            bezierAnchorHandles: '選取錪點控制點',
            bezierHandle_aligned: '對齊',
            bezierHandle_vector: '向量',
            bezierHandle_free: '自由',
            bezierHandleSide_left: '左側',
            bezierHandleSide_right: '右側',
            tbcHeading: '針目',
            tbcsHeading: '針目',
            panelTitle: '檢視器',
            emptyState: '選取針目或參考線以查看其屬性。',
            collapse: '收合面板',
            expand: '展開面板',
            close: '關閉面板',
            groupOrder: {
                title: '群組順序',
                flip: '翻轉前後',
                ungroup: '取消群組',
                detachMember: '從群組分離',
                bringToFront: '移至最上層',
                bringForward: '上移一層',
                sendBackward: '下移一層',
                sendToBack: '移至最下層',
            },
            perTopHeading: '各頂部',
            roundLabel: '行/段',
            ringRadius: '半徑：{{radius}}',
            setAllTops: '套用至所有頂部',
            multiSelected: '已選取 {{count}} 個針目',
            editShape: '編輯形狀',
            guidesSelected: '已選取 {{count}} 個參考線',
            setRoundForSelection: '設定所有針目的行/段',
            clearRound: '清除',
            topUserRoundLabel: '覆寫',
            orderLabel: '順序',
            setOrderForSelection: '設定所有針目的順序',
            orderNoRound: '未指定段數',
            sourceMixed: '混合',
            sourceFree: '無',
            sourceDisagreement: '衝突',
            sourceCycle: '循環',
            source: {
                user: '使用者',
                guide: '參考線',
                inferred: '推斷',
            },
            verticalLinksTitle: '垂直連結',
            verticalParentsLabel: '父針目',
            verticalChildrenLabel: '子針目',
            verticalNoLinks: '沒有垂直連結',
            verticalUnlink: '解除連結',
            verticalShowOnCanvas: '顯示',
            verticalHideOnCanvas: '隱藏',
            verticalLegendParent: '父針端',
            verticalLegendChild: '子針端',
            verticalIssueRoundOrder: '父針目的段數晚於子針目',
            verticalIssueMixed: '端點沒有單一段數',
            spaceTitle: '空隙',
            spaceChainCount: '{{n}} 鎖針空隙',
            spaceNoGuide: '未挑入參考線',
            spaceGuideLabel: '參考線',
            spaceSetGuide: '設定挑入參考線…',
            spaceClearGuide: '清除參考線',
            spaceDissolve: '解散空隙',
            spaceGuideTaken: '這條參考線已被另一個空隙使用。',
            spaceGuideChainSnapped: '此空隙的鎖針已吸附在這條參考線上，無法設為挑入參考線。',
            sectionRoundOrder: '段數與順序',
            sectionColor: '顏色',
            colorMixed: '多種顏色',
            sectionFollowTangent: '參考線切線',
            followTangent: {
                label: '跟隨參考線切線',
                hint: '跟隨時頂端角度會被鎖定。',
                on: '開啟',
                off: '關閉',
                mixed: '混合',
            },
            rectSizeHeading: '尺寸',
            rectWidthLabel: '寬度',
            rectHeightLabel: '高度',
            rectSizeValue: '{{value}}×',
            rectSizeMixed: '混合',
            rectHeightPinned: '兩端都已附著於參考線，因此高度固定。解除其中一端的附著即可調整大小。',
            cluster: {
                memberType: '組成針法',
                count: '針數',
                countMinus: '減少玉針針數',
                countPlus: '增加玉針針數',
                into: {
                    label: '編入方式',
                    stitch: '挑針（挑針目）',
                    space: '挑束（挑束）',
                },
            },
            popcorn: {
                memberType: '組成針法',
                count: '針數',
                countMinus: '減少爆米花針數',
                countPlus: '增加爆米花針數',
                into: {
                    label: '編入方式',
                    stitch: '挑針（挑針目）',
                    space: '挑束（挑束）',
                },
            },
        },

        propertiesColumn: {
            collapse: '隱藏面板',
            resize: '調整面板寬度',
            expand: '顯示面板',
        },

        headerTray: {
            collapse: '隱藏標題列',
            expand: '顯示標題列',
        },

        commandKeyToggle: {
            label: '加入選取',
            tooltipOn: '加入選取已開啟 — 點按項目以加入或移除，拖曳可切換區域。點按以關閉。',
            tooltipOff: '加入選取 — 點按項目以加入或移除，拖曳可切換區域。',
        },

        altKeyToggle: {
            label: 'Alt 操作',
            tooltipOn: 'Alt 操作已開啟 — 點按吸附的控制點可切換選取哪一個，點按針目主體可選取其全部控制點。點按以關閉。',
            tooltipOff: 'Alt 操作 — 點按吸附的控制點可切換選取哪一個，點按針目主體可選取其全部控制點。',
        },

        crochetStepper: {
            extend: '加長',
            shrink: '縮短',
        },

        quickAccess: {
            title: '快速存取',
            empty: '在任一選單項目上按滑鼠右鍵，即可將其加入這裡。',
            add: '加入快速存取',
            remove: '從快速存取移除',
        },

        crochetContextMenu: {
            addRingAbove: '在上方新增環',
            addRingBelow: '在下方新增環',
            finishPlacement: '完成',
            cancelPlacement: '取消',
            removeRing: '移除環',
            deleteGuide: '刪除參考線',
            addStitchesAlongGuide: '新增針目…',
            selectAllHandlesOnGuide: '選取所有控制點',
            selectAllTopsOnGuide: '選取所有頂部',
            selectAllBasesOnGuide: '選取所有底部',
            doneEditing: '完成編輯',
            editBezier: '編輯貝茲曲線',
            distributeBasesEvenly: '平均分佈底部',
            distributeTopsEvenly: '平均分佈頂部',
            distributeBothEvenly: '平均分佈兩者',
            spreadBasesAcrossGuide: '將底部散佈到參考線上…',
            spreadTopsAcrossGuide: '將頂部散佈到參考線上…',
            spreadBasesBetweenPoints: '在兩點之間分散底部…',
            spreadTopsBetweenPoints: '在兩點之間分散頂部…',
            spreadBetweenPointsHintStart: '點擊參考線上的一個點作為起點。點擊針目可在其旁邊停止。',
            spreadBetweenPointsHintEnd: '點擊分散範圍的終點。',
            projectBasesOntoGuide: '將底部投影到參考線上…',
            projectTopsOntoGuide: '將頂部投影到參考線上…',
            projectBothOntoGuide: '將兩者投影到參考線上…',
            slideAlongGuide: '沿參考線滑動',
            slideAlongGuideKeepOrientation: '沿參考線滑動（保持方向）',
            distributeSnappedBasesBetween: '在端點之間分佈已貼齊的底部',
            distributeSnappedTopsBetween: '在端點之間分佈已貼齊的頂部',
            distributeSnappedBothBetween: '在端點之間分佈已貼齊的底部與頂部',
            rewidthToFillGuide: '調整寬度以填滿參考線',
            alignRadially: '徑向對齊',
            alignRadiallyToBase: '以底部為準徑向對齊',
            alignRadiallyToTop: '以頂部為準徑向對齊',
            alignToNormal: '對齊法線方向',
            alignToBaseNormal: '對齊底部法線方向',
            alignToTopNormal: '對齊頂部法線方向',
            alignDirection: '對齊方向',
            guide: '參考線',
            detach: '分離',
            link: '連結',
            align: '對齊',
            horizontal: '水平',
            vertical: '垂直',
            top: '上',
            bottom: '下',
            left: '左',
            right: '右',
            distribute: '分佈',
            horizontally: '水平分佈',
            vertically: '垂直分佈',
            addStitchOnTop: '在頂部新增針目…',
            addIncreaseOnTop: '在頂部新增加針…',
            addStitchUnder: '在底部新增針目…',
            addIncreaseUnder: '在底部新增加針…',
            singleCrochet: '短針',
            nTops: '{{count}} 個頂部',
            resetGap: '重設間距',
            detachFromParent: '從父針目分離',
            detachFromParents: '從父針目分離（{{count}} 個）',
            breakConnectionHere: '在此中斷連接',
            detachHandleFromGuide: '從參考線分離控制點',
            detachHandlesFromGuides: '從參考線分離 {{count}} 個控制點',
            detachBaseFromGuide: '從參考線分離底部',
            detachBasesFromGuides: '從參考線分離 {{count}} 個底部',
            detachTopFromGuide: '從參考線分離頂部',
            detachTopsFromGuides: '從參考線分離 {{count}} 個頂部',
            copy: '複製',
            pasteHere: '貼到這裡',
            sheetTitle: '操作',
            back: '返回',
            toastAligned: '已對齊 {{applied}} 個 — 略過 {{skipped}} 個（已貼齊參考線或已附著）。',
            toastAlignedNone: '沒有控制點可對齊 — 略過 {{skipped}} 個（已貼齊參考線或已附著）。',
            toastDistributed: '已分佈 {{applied}} 個 — 略過 {{skipped}} 個（已貼齊參考線或已附著）。',
            toastDistributedNone: '沒有控制點可分佈 — 略過 {{skipped}} 個（已貼齊參考線或已附著）。',
            toastRadialAligned: '已對齊 {{applied}} 個 — 略過 {{skipped}} 個（沒有符合的貼齊，或參考線無法滿足徑向方向）。',
            toastRadialAlignedNone: '沒有針目可對齊 — 略過 {{skipped}} 個（沒有符合的貼齊，或參考線無法滿足徑向方向）。',
            toastNormalAligned: '已對齊 {{applied}} 個 — 略過 {{skipped}} 個（沒有符合的貼齊，或參考線無法滿足法線方向）。',
            toastNormalAlignedNone: '沒有針目可對齊 — 略過 {{skipped}} 個（沒有符合的貼齊，或參考線無法滿足法線方向）。',
            flipHorizontal: '水平翻轉',
            flipVertical: '垂直翻轉',
            toastFlipped: '已翻轉 {{applied}} 個項目，略過 {{skipped}} 個（已貼齊參考線或已連結）。',
            toastFlippedNone: '沒有任何項目被翻轉，略過 {{skipped}} 個（已貼齊參考線或已連結）。',
            toastDirectionAligned: '已對齊 {{applied}} 個 — 略過 {{skipped}} 個（根針目沒有方向，或頂部已貼齊參考線）。',
            toastDirectionAlignedNone: '沒有針目可對齊 — 略過 {{skipped}} 個（根針目沒有方向，或頂部已貼齊參考線）。',
            handleAligned: '對齊',
            handleVector: '向量',
            handleFree: '自由',
            linkAsParent: '連結為…的父針目',
            linkAsChild: '連結為…的子針目',
            makeGroup: '群組',
            flipGroup: '翻轉前後',
            detachFromGroup: '從群組分離',
            ungroup: '取消群組',
            markTurningChain: '標記為起立針',
            removeTurningChain: '取消起立針標記',
            assignAsSpace: '設為空隙',
            bringToFront: '移至最前',
            bringForward: '上移一層',
            sendBackward: '下移一層',
            sendToBack: '移至最後',
        },

        crochetGroupsPanel: {
            title: '群組',
            empty: '尚無群組',
            groupLabel: '群組 {{n}}',
            togglePanel: '群組',
            highlight: '在畫布上強調顯示',
            flip: '翻轉前後',
            disband: '取消群組',
            select: '選取群組',
            cutUnder: '交叉針斷線顯示',
        },

        crochetAddStitchesDialog: {
            title: '在參考線上新增針目',
            count: '數量',
            startAngle: '起始角度',
            decrement: '減少數量',
            increment: '增加數量',
            stitchType: '針目種類',
            orient: '沿著參考線方向',
            orientOn: '開',
            orientOff: '關',
            snapBy: '貼齊基準',
            snapByBase: '底部',
            snapByTop: '頂部',
            autoWidth: '自動寬度 — 填滿參考線',
            autoWidthOn: '開',
            autoWidthOff: '關',
            width: '針目寬度',
            height: '針目高度',
            scaleValue: '{{value}}×',
            lockAspectRatio: '鎖定長寬比',
            lockAspectRatioOn: '開啟',
            lockAspectRatioOff: '關閉',
            cancel: '取消',
            add: '新增',
        },

        crochetCombination: {
            modeSingle: '單一',
            modeCombination: '組合',
            textboxLabel: '組合',
            textboxPlaceholder: 'e.g. sc, dc, ch',
            repeats: '重複次數',
            summary: '{{combo}} · ×{{repeats}} = {{total}} 針',
            summaryWithSlots: '{{combo}} · ×{{repeats}} = {{stitches}} 針（{{slots}} 個針位）',
            unknownStitch: '未知的針法：{{token}}',
            unbalancedParens: '括號未配對',
            invalidRepeat: '重複次數無效',
            emptyGroup: '空的群組',
            tooManyStitches: '針目數量過多',
        },

        editorLayer: {
            group: '編輯圖層',
            stitch: '針目',
            stitchTooltip: '針目圖層（1）',
            annotation: '註記',
            annotationTooltip: '註記圖層（2）',
            select: '選取',
            startMarker: '起編記號',
            endMarker: '結束記號',
            startMarkerTooltip: '放置起編記號（空心三角）',
            endMarkerTooltip: '放置結束記號（實心三角）',
            line: '線條',
            lineTooltip: '繪製連接線（按住拖曳；端點會貼齊針目）',
            curve: '曲線',
            curveTooltip: '繪製曲線連接線（按住拖曳；端點會貼齊針目）',
            circle: '圓形',
            circleTooltip: '放置圓形（點擊；連按兩下可拖曳圓心和半徑）',
            arc: '弧線',
            arcTooltip: '放置弧線（點擊；連按兩下可拖曳圓心、半徑和兩端）',
            text: '文字',
            textTooltip: '放置文字標籤（點擊後輸入文字；按 Esc 或點擊完成按鈕結束）',
        },

        annotationInspector: {
            panelTitle: '註記',
            empty: '註記圖層目前沒有可檢視的內容。',
            angle: '角度（°）',
            width: '寬度（%）',
            height: '高度（%）',
            delete: '刪除',
            color: '顏色',
            multi: {
                count_one: '已選取 {{count}} 個註記',
                count_other: '已選取 {{count}} 個註記',
            },
            symbol: {
                start: '起編記號',
                end: '結束記號',
                path: '連接線',
                bezier: '曲線',
                circle: '圓形',
                arc: '弧線',
                text: '文字標籤',
            },
            text: {
                content: '文字',
                size: '字級',
                fontFamily: '字型',
                families: {
                    sans: '無襯線',
                    serif: '襯線',
                    mono: '等寬',
                },
                bold: '粗體',
                italic: '斜體',
                underline: '底線',
                boldAbbrev: 'B',
                italicAbbrev: 'I',
                underlineAbbrev: 'U',
            },
            path: {
                startCap: '起點端頭',
                endCap: '終點端頭',
                style: '線條樣式',
                width: '寬度（×）',
                anchor: '錨點 {{n}}',
                bound: '已附著於針目',
                free: '自由',
            },
            caps: {
                none: '無',
                arrow: '箭頭',
                dot: '圓點',
                bar: '橫線',
            },
            styles: {
                solid: '實線',
                dashed: '虛線',
                dotted: '點線',
            },
            bezier: {
                edit: '編輯形狀',
                addAnchor: '新增錨點',
                removeAnchor: '移除錨點',
                handles: '控制點',
            },
            handleTypes: {
                aligned: '對齊',
                vector: '向量',
                free: '自由',
            },
            handleSides: {
                left: '左側',
                right: '右側',
            },
        },

        annotationActionRail: {
            undo: '復原',
            redo: '重做',
            delete: '刪除',
            duplicate: '複製',
        },

        annotationToolbar: {
            editingCurve: '正在編輯曲線',
            editingCircle: '正在編輯圓形',
            editingArc: '正在編輯弧線',
            editingText: '編輯文字中',
            exitEditMode: '結束編輯模式',
            color: '註記顏色',
        },

        annotationTextEditor: {
            label: '註記文字',
        },

        crochetToolbar: {
            stitch: '針目',
            stitchTool: '針目工具',
            guide: '參考線',
            guideTool: '參考線工具',
            place: '放置',
            edit: '編輯',
            chain: '鏈條',
            chainTooltip: '鏈條（移動／旋轉）',
            sizing: '調整大小',
            sizingTooltip: '調整鏈條橢圓寬度',
            advanced: '進階',
            advancedTooltip: '調整頂端／橫桿角度與橫桿位置',
            editingGuide: '編輯參考線',
            exitEditMode: '結束',
        },

        crochetActionToolbar: {
            undo: '復原',
            redo: '重做',
            copy: '複製',
            paste: '貼上',
            pasteWithStitches: '貼上並帶上貼齊的針目',
            pasteWithStructure: '貼上並帶上針目結構',
            duplicate: '重複（重複上一個操作）',
            delete: '刪除',
            alignDirection: '對齊方向',
            alignDirectionHint: '畫一條線來設定方向',
            toastDirectionLineAligned: '已對齊 {{applied}} 個 — 略過 {{skipped}} 個（已貼齊參考線或沒有方向）。',
            toastDirectionLineAlignedNone: '沒有針目可對齊 — 略過 {{skipped}} 個（已貼齊參考線或沒有方向）。',
            link: '連結針目',
        },

        gridActionToolbar: {
            undo: '復原',
            redo: '重做',
        },

        // Stitch names
        stitch: {
            purl: '上針',
            knitBar: '下針（豎線）',
            purlBar: '上針（橫線）',
            slip: '滑針',
            slipWyif: '滑針 wyif',
            slipWyifCross: '滑針 wyif（交叉）',
            slipWyifFilled: '滑針 wyif（實心）',
            slipWyifFilledBar: '滑針 wyif（實心橫線）',
            knitTbl: '扭下針',
            purlTbl: '扭上針',
            purlTblBar: '扭上針（橫線）',
            knitTblArrow: '扭下針（箭頭）',
            purlTblArc: '扭上針（弧線）',
        },

        crochet: {
            chainUp: '鎖針（直向）',
            chainCenter: '鎖針（橫向）',
            slipStitch: '引拔針',
            singleCrochetX: '短針（×）',
            singleCrochetCrosshair: '短針（十字）',
            halfDoubleCrochet: '中長針',
            title: '鉤針編織',
        },

        crochetRail: {
            stitch: {
                'double-crochet': '長針',
                'half-double-crochet': '中長針',
                'treble-crochet': '長長針',
                'double-treble-crochet': '三捲長針',
                chain: '鎖針',
                'chain-full': '鎖針（全長）',
                'single-crochet': '短針',
                'single-crochet-full': '短針（全長）',
                'single-crochet-x': '短針（×）',
                'single-crochet-x-full': '短針（× 全長）',
                'single-crochet-directional': '短針（方向）',
                'single-crochet-directional-full': '短針（方向・全長）',
                'reverse-single-crochet': '蟹形針',
                'reverse-single-crochet-full': '蟹形針（全長）',
                'reverse-single-crochet-x': '蟹形針（×）',
                'reverse-single-crochet-x-full': '蟹形針（× 全長）',
                'twisted-single-crochet': '扭短針',
                'twisted-single-crochet-full': '扭短針（全長）',
                'twisted-single-crochet-x': '扭短針（×）',
                'twisted-single-crochet-x-full': '扭短針（× 全長）',
                'slip-stitch': '引拔針',
                cluster: '玉針',
                popcorn: '爆米花針',
                'front-post-single-crochet': '表引短針',
                'front-post-half-double-crochet': '表引中長針',
                'front-post-double-crochet': '表引長針',
                'front-post-treble-crochet': '表引長長針',
                'front-post-double-treble-crochet': '表引三捲長針',
                'back-post-single-crochet': '裏引短針',
                'back-post-half-double-crochet': '裏引中長針',
                'back-post-double-crochet': '裏引長針',
                'back-post-treble-crochet': '裏引長長針',
                'back-post-double-treble-crochet': '裏引三捲長針',
            },
            increase: '加針 — 短針',
            decrease: '減針 — 短針',
            guide: {
                line: '直線',
                'concentric-circles': '同心圓',
                'magic-ring': '魔術環（輪）',
                'concentric-arcs': '同心弧',
                'bezier-curve': '貝茲曲線',
            },
            asym: {
                increase: {
                    'single-crochet': '加針 — 短針',
                    'double-crochet': '加針 — 長針',
                    'half-double-crochet': '加針 — 中長針',
                    'treble-crochet': '加針 — 長長針',
                    'double-treble-crochet': '加針 — 三捲長針',
                    'front-post-single-crochet': '加針 — 表引短針',
                    'front-post-half-double-crochet': '加針 — 表引中長針',
                    'front-post-double-crochet': '加針 — 表引長針',
                    'front-post-treble-crochet': '加針 — 表引長長針',
                    'front-post-double-treble-crochet': '加針 — 表引三捲長針',
                    'back-post-single-crochet': '加針 — 裏引短針',
                    'back-post-half-double-crochet': '加針 — 裏引中長針',
                    'back-post-double-crochet': '加針 — 裏引長針',
                    'back-post-treble-crochet': '加針 — 裏引長長針',
                    'back-post-double-treble-crochet': '加針 — 裏引三捲長針',
                },
                decrease: {
                    'single-crochet': '減針 — 短針',
                    'double-crochet': '減針 — 長針',
                    'half-double-crochet': '減針 — 中長針',
                    'treble-crochet': '減針 — 長長針',
                    'double-treble-crochet': '減針 — 三捲長針',
                    'front-post-single-crochet': '減針 — 表引短針',
                    'front-post-half-double-crochet': '減針 — 表引中長針',
                    'front-post-double-crochet': '減針 — 表引長針',
                    'front-post-treble-crochet': '減針 — 表引長長針',
                    'front-post-double-treble-crochet': '減針 — 表引三捲長針',
                    'back-post-single-crochet': '減針 — 裏引短針',
                    'back-post-half-double-crochet': '減針 — 裏引中長針',
                    'back-post-double-crochet': '減針 — 裏引長針',
                    'back-post-treble-crochet': '減針 — 裏引長長針',
                    'back-post-double-treble-crochet': '減針 — 裏引三捲長針',
                },
                flyoutTitle: '加針與減針',
                increaseSection: '加針',
                decreaseSection: '減針',
                more: '所有加針與減針',
                pin: '釘選到側欄',
                unpin: '從側欄移除',
            },
            scrollUp: '向上捲動',
            scrollDown: '向下捲動',
            moreStitches: '所有針法',
            category: {
                all: '全部',
                basic: '基本',
                posts: '引上針',
                clusters: '玉針',
                textured: '織紋',
                special: '特殊',
            },
            flyout: {
                title: '針法',
                searchPlaceholder: '搜尋針法…',
                noResults: '沒有符合搜尋的針法。',
                pin: '釘選到側欄',
                unpin: '從側欄移除',
            },
        },

        crochetPieMenu: {
            scGroup: '短針…',
            incDecGroup: '加針／減針…',
            postsGroup: '表引針…',
            backPostsGroup: '裏引針…',
        },

        nav: {
            menuLabel: '開啟導覽選單',
            home: '首頁',
            knit: '棒針編織',
            crochet: '鉤針編織',
            help: '說明',
            feedback: '提供意見回饋',
        },

        // Landing page
        landing: {
            tagline: '視覺化編織圖案編輯器。',
            openEditor: '開啟編輯器',
            knitTitle: '棒針編織',
            knitDescription: '在網格上設計棒針編織圖。',
            crochetTitle: '鉤針編織',
            crochetDescription: '使用針法圖示設計鉤針編織圖案。',
            patternTitle: '織圖教學文件',
            patternDescription: '以文字與圖解編寫編織圖案。',
        },

        offlineBoot: {
            copying: '正在複製您的作品… {{done}} / {{total}}',
            copyFailed: '無法複製您的作品。下次啟動 {{appName}} 時會再試一次。',
        },

        copyCode: {
            copied: '已複製',
            fallback: '請複製此代碼：',
        },

        offlineSite: {
            landing: {
                title: '{{appName}} 離線應用程式',
                getIt: '請在 {{appName}} → 設定 → 離線應用程式中取得。',
            },
            install: {
                title: '安裝 {{appName}}',
                preparing: '正在準備下載…',
                progress: '正在下載 {{appName}} {{version}}… {{done}} / {{total}} 個檔案',
                ready: '準備就緒 — 無需網路即可使用',
                installButton: '安裝應用程式',
                openNow: '立即開啟',
                safariDock: '「檔案 > 加入 Dock」',
                iosHomeScreen: '「分享」→「加入主畫面」',
                bookmark: '已可在此分頁中使用 — 請將它加入書籤。',
                retry: '再試一次',
                copyingStart: '正在從 {{appName}} 複製您的作品…',
                copying: '正在從 {{appName}} 複製您的作品… {{done}} / {{total}}',
                skip: '略過',
                workCopied_one: '已複製您的作品（{{count}} 個項目）。',
                workCopied_other: '已複製您的作品（{{count}} 個項目）。',
                workNotCopied: '您的作品未被複製。您可以稍後從設定 → 您的資料匯入。',
                openFromDock: '請從 Dock 開啟 {{appName}}，安裝將在該處完成。',
                openFromHomeScreen: '請從主畫面開啟 {{appName}}，安裝將在該處完成。',
                copyInstallCode: '複製安裝碼',
                installedInApp: '已安裝',
                importHintInApp: '若要帶入您的作品，請在 Safari 的 {{appName}} 中使用「全部匯出」（設定 → 您的資料），然後在這裡「匯入」。',
            },
            finish: {
                title: '完成安裝 {{appName}}',
                pasteLabel: '貼上安裝碼',
                continue: '繼續',
                notACode: '這不是安裝碼。',
                expired: '此代碼已過期。請在 {{appName}} → 設定 → 離線應用程式中取得新的代碼。',
            },
            update: {
                title: '更新 {{appName}}',
                ready: '已更新 — 正在開啟 {{appName}}…',
            },
            errors: {
                expired: '此連結已過期。請返回 {{appName}}，再點選一次「取得離線應用程式」。',
                unauthorized: '此連結無效。請返回 {{appName}}，再點選一次「取得離線應用程式」。',
                'missing-token': '此頁面需要安裝連結。請返回 {{appName}} 並點選「取得離線應用程式」。',
                'not-enough-storage': '空間不足：需要約 {{mb}} MB 的可用空間。',
                network: '下載中斷。請檢查您的網路連線，然後再試一次。',
                integrity: '下載的內容與預期不符，因此已捨棄。請再試一次。',
                'no-build': '離線應用程式尚未提供。請稍後再試。',
                unsupported: '此瀏覽器無法執行離線應用程式。請改用最新版的 Chrome、Edge、Safari 或 Firefox。',
            },
        },

        offlineUpdate: {
            title: '更新離線應用程式',
            upToDate: '您使用的已是最新版本。',
            subscribe: '您已安裝的 {{from}} 仍可繼續使用。訂閱即可取得 {{current}}。',
            subscribeNoFrom: '您已安裝的離線應用程式仍可繼續使用。訂閱即可取得 {{current}}。',
            trial: '離線應用程式包含於付費方案中。',
            updating: '正在準備您的更新…',
            unavailable: '目前無法使用離線應用程式。',
            error: '無法開始更新。請再試一次。',
            copyUpdateCode: '複製更新碼',
            codeSteps: '請在 {{appName}}（離線版）中貼上：設定 → 資訊 → 貼上更新碼。此代碼在 15 分鐘內有效。',
        },

        dashboard: {
            title: '您的工作區',
            filterAll: '全部',
            filterCrochet: '鉤針',
            filterKnit: '棒針',
            filterPatterns: '織圖',
            filterArchived: '已封存',
            bandCrochet: '鉤針編織',
            bandKnit: '棒針編織',
            bandPatterns: '織圖教學文件',
            seeAll: '查看全部',
            newButton: '新增',
            newCrochet: '新增鉤針編織',
            newKnit: '新增棒針編織',
            newPattern: '新增織圖文件',
            empty: '這裡還沒有任何內容 — 點選「新增」建立您的第一個作品。',
            loadFailed: '無法載入您的工作區，請再試一次。',
            storageUnavailable: '此瀏覽器無法使用儲存空間。',
            importHint: '您在線上版 {{appName}} 有作品嗎？',
            importHintLink: '匯入您的作品',
            counter: '有效織圖：{{used}} / {{limit}}',
        },

        notFound: {
            title: '好像漏了一針',
            description: '這個頁面似乎脫線了——已經不在這裡了。',
            backHome: '返回首頁',
        },

        patternEditor: {
            title: '織圖教學文件編輯器',
            description: '以豐富文字與圖解編寫鉤針或棒針編織圖案。',
            textPlaceholder: '輸入您的編織說明…',
            fonts: {
                warningTitle: '編織書寫的字型未能載入',
                warningDescription: 'PDF 可能改用其他字型，分頁位置也可能不同。',
                notice: '{{fonts}}未能載入，因此目前不會儲存分頁位置。恢復連線後請重新載入。',
                warning: '{{fonts}}未能載入：PDF 的換行與分頁可能與編輯時不同。',
            },
            legend: {
                insert: '插入針法圖例',
                emptyChart: '此織圖尚無針目',
                deleteRow: '刪除此列',
                tooLarge: '此織圖的針法太多，無法製成圖例。',
                refreshFromChart: '從織圖更新',
                // The data-mode error panel's way out (legend and written instructions alike).
                close: '關閉',
                refreshConfirm: {
                    title: '要取代您的編輯嗎？',
                    body: '更新會以織圖目前的針目取代此區塊，您對它所做的編輯將會遺失。',
                    confirm: '更新',
                    cancel: '取消',
                },
            },
            instructions: {
                insert: '插入文字說明',
                notesOmitted_one: '已插入。有 {{count}} 則織圖備註未納入，請檢查織圖。',
                notesOmitted_other: '已插入。有 {{count}} 則織圖備註未納入，請檢查織圖。',
                emptyChart: '此織圖尚無可寫成文字說明的針目',
                notesOmittedRefresh_one: '已更新。有 {{count}} 則織圖備註未納入，請檢查織圖。',
                notesOmittedRefresh_other: '已更新。有 {{count}} 則織圖備註未納入，請檢查織圖。',
                tooLarge: '此織圖太大，無法插入為文字說明。',
            },
            paperErrors: {
                edge: '超出紙張邊緣，會被裁切',
                tooTall: '此段落比一頁還高',
                warning: {
                    title: '部分內容會被裁切',
                    description: '這些頁面上有內容放不進紙張，匯出的 PDF 中會被裁切。',
                    page: '第 {{page}} 頁：{{reasons}}',
                    goBack: '返回',
                    exportAnyway: '仍要匯出',
                    // Short forms for the per-page list, which joins them mid-sentence.
                    reasons: {
                        edge: '超出紙張邊緣',
                        tooTall: '比一頁還高的段落',
                    },
                },
            },
            exportPdf: '匯出 PDF',
            addText: '新增文字框',
            addImage: '新增圖片',
            addDiagram: '新增織圖',
            resizeElement: '調整區塊大小',
            language: {
                label: '編織書寫語言',
            },
            snap: {
                button: '貼齊',
                hint: '貼齊頁面邊緣、邊界與其他元素。拖曳時按住 Cmd 或 Ctrl 可自由擺放。',
            },
            // 對齊、均分與選取（SP-149、SP-150），與文字對齊不同。
            arrange: {
                title: '排列',
                alignLeft: '靠左對齊',
                alignCentre: '水平置中',
                alignRight: '靠右對齊',
                alignTop: '靠上對齊',
                alignMiddle: '垂直置中',
                alignBottom: '靠下對齊',
                distributeH: '水平均分',
                distributeV: '垂直均分',
                toSelection: '對齊選取範圍',
                toPage: '對齊頁面',
                selectMode: '選取',
                selectMore: '選取更多',
            },
            // The running header and footer dialog (SP-144). {page}, {pages} and {name} stay literal in every language.
            headerFooter: {
                button: '頁首與頁尾',
                title: '頁首與頁尾',
                description: '顯示在這份編織書寫每一頁的邊界內。',
                header: '頁首',
                footer: '頁尾',
                left: '左',
                center: '中',
                right: '右',
                insertPage: '頁碼',
                insertPages: '總頁數',
                insertName: '編織書寫名稱',
                insertPreset: '第 1 頁，共 5 頁',
                hint: '{page}、{pages} 和 {name} 會顯示為頁碼、總頁數和編織書寫名稱。',
                hideOnFirstPage: '第一頁（封面）不顯示',
                preview: '預覽',
                previewPage: '第 {{number}} 頁',
                done: '完成',
                cancel: '取消',
            },
            margins: {
                button: '邊界',
                title: '頁面邊界',
                description: '每一頁內容四周留白的寬度。區塊維持原位，文字會重新排版。',
                top: '上',
                right: '右',
                bottom: '下',
                left: '左',
                unitIn: '吋',
                unitMm: '公釐',
                invalid: '邊界不可為負數，且內容區的寬與高都要至少保留 1 吋（25 公釐）。',
                invalidBand: '圖樣有頁首或頁尾時，上、下邊界至少要 0.25 吋（6.4 公釐）。',
                apply: '套用',
                cancel: '取消',
            },
            paperSize: {
                label: '紙張大小',
                letter: 'Letter（8.5 × 11 吋）',
                a4: 'A4（210 × 297 公釐）',
            },
            menu: {
                cut: '剪下',
                copy: '複製',
                paste: '貼上',
                delete: '刪除',
                duplicate: '複製一份',
                bringToFront: '移到最前',
                bringForward: '上移一層',
                sendBackward: '下移一層',
                sendToBack: '移到最後',
                refreshDiagram: '從織圖更新',
            },
            pages: {
                label: '第 {{number}} 頁',
                actions: '第 {{number}} 頁的操作',
                add: '新增頁面',
                newPageSlot: '拖放到這裡以新增頁面',
                addAfter: '在此頁後新增頁面',
                moveUp: '將頁面上移',
                moveDown: '將頁面下移',
                delete: '刪除頁面',
                deleteTitle: '要刪除第 {{number}} 頁嗎？',
                deleteBody_one: '此頁上的區塊也會一併刪除。',
                deleteBody_other: '此頁上的 {{count}} 個區塊也會一併刪除。',
                cancel: '取消',
                confirmDelete: '刪除頁面',
            },
            zoom: {
                in: '放大',
                out: '縮小',
                fitPage: '整頁顯示',
                fitWidth: '符合寬度',
                level: '縮放比例',
            },
            textFlow: {
                continuation: '接續的文字。拖曳可在此頁移動，拖曳邊緣可調整大小。',
                resetContinuation: '重設位置與大小',
            },
            history: {
                undoStep: '復原{{step}}',
                redoStep: '重做{{step}}',
                steps: {
                    addText: '新增文字方塊',
                    addImage: '新增圖片',
                    insertChart: '插入圖表',
                    refreshChart: '重新整理圖表',
                    insertLegend: '插入圖例',
                    editLegend: '編輯圖例',
                    refreshLegend: '重新整理圖例',
                    insertInstructions: '插入編織書寫',
                    refreshInstructions: '重新整理編織書寫',
                    move: '移動',
                    resize: '調整大小',
                    moveContinuation: '移動接續文字',
                    resizeContinuation: '調整接續文字大小',
                    resetContinuation: '重設接續文字',
                    editText: '文字編輯',
                    delete: '刪除',
                    duplicate: '複製',
                    bringToFront: '移到最前',
                    paperSize: '紙張大小',
                    patternLanguage: '編織書寫語言',
                    headerFooter: '頁首與頁尾',
                    addPage: '新增頁面',
                    deletePage: '刪除頁面',
                    movePage: '移動頁面',
                    bringForward: '上移一層',
                    sendBackward: '下移一層',
                    sendToBack: '移到最後',
                    align: '對齊',
                    distribute: '均分',
                    nudge: '微移',
                    nudgeContinuation: '微移接續文字',
                    margins: '邊界',
                },
            },
            toolbar: {
                undo: '復原',
                redo: '重做',
                blockType: '文字樣式',
                blockNormal: '內文',
                blockH1: '標題 1',
                blockH2: '標題 2',
                blockH3: '標題 3',
                blockBullet: '項目符號清單',
                blockNumbered: '編號清單',
                blockCheck: '待辦清單',
                blockQuote: '引言',
                blockCode: '程式碼區塊',
                fontFamily: '字型',
                fontSize: '字級',
                decreaseFontSize: '縮小字級',
                increaseFontSize: '放大字級',
                bold: '粗體',
                italic: '斜體',
                underline: '底線',
                code: '行內程式碼',
                link: '插入連結',
                bulletList: '項目符號清單',
                numberedList: '編號清單',
                moreFormats: '更多文字格式',
                strikethrough: '刪除線',
                subscript: '下標',
                superscript: '上標',
                clearFormatting: '清除格式',
                textColor: '文字顏色',
                bgColor: '背景顏色',
                customColor: '自訂顏色',
                align: '對齊',
                alignLeft: '靠左對齊',
                alignCenter: '置中對齊',
                alignRight: '靠右對齊',
                alignJustify: '左右對齊',
                indent: '增加縮排',
                outdent: '減少縮排',
                linkPrompt: '輸入網址：',
                scrollLeft: '向左捲動工具列',
                scrollRight: '向右捲動工具列',
            },
            pdfExport: {
                preparing: '正在準備 PDF…',
                ready: 'PDF 已準備好。',
                save: '儲存 PDF',
                offlineFallback: '製作 PDF 檔案需要連線到 {{appName}}。改為開啟列印對話框，請選擇「另存為 PDF」。',
                failedFallback: '無法製作 PDF 檔案。改為開啟列印對話框，請選擇「另存為 PDF」。',
            },
        },

        gridPieMenu: {
            knit: '下針',
            purl: '上針',
            'knit-bar': '下針（豎線）',
            'purl-bar': '上針（橫線）',
            empty: '空白',
            slipGroup: '滑針…',
            slip: '滑針',
            'slip-wyif': '滑針 wyif',
            'slip-wyif-cross': '滑針 wyif（交叉）',
            'slip-wyif-filled': '滑針 wyif（實心）',
            'slip-wyif-filled-bar': '滑針 wyif（實心橫線）',
            tblGroup: '扭針…',
            'knit-tbl': '扭下針',
            'purl-tbl': '扭上針',
            'purl-tbl-bar': '扭上針（橫線）',
            'knit-tbl-arrow': '扭下針（箭頭）',
            'purl-tbl-arc': '扭上針（弧線）',
        },

        // Icon Handoff Page
        iconHandoff: {
            title: '圖示交接',
            intro: '此頁面列出應用程式中使用的所有圖示。設計師可以將替換的 SVG 放入',
            introCode: 'public/designer-icons/<slug>/<slug>.svg',
            introClosing: '，它們將顯示在「設計師」欄位中。',
            conventionTitle: '慣例',
            conventionBody:
                '所有圖示均從 @/assets/icons 匯入。自製的 SVG 圖示放在 src/assets/icons/ 中作為 React 元件。Lucide 圖示從單一 lucide.ts 檔案重新匯出。',
            sectionCustomTitle: '自訂應用程式圖示',
            sectionCustomSubtitle: '自製的 React SVG 元件。',
            sectionLucideTitle: 'Lucide 圖示',
            sectionLucideSubtitle: '從 lucide-react 重新匯出。請勿在其他地方直接匯入 lucide-react。',
            sectionCursorsTitle: '游標',
            sectionCursorsSubtitle:
                'SVG 原始檔位於 src/assets/cursors/，由 scripts/build-cursors.sh 轉出 public/cursors/ 中 32px/64px 的 PNG。作用點（hotspot）是 @1x 座標下的有效像素，定義於 src/cursors/cursor-registry.ts。',
            tableName: '匯出名稱',
            tableState: '狀態',
            tableCurrent: '目前',
            tableDesigner: '設計師',
            tableHotspot: '作用點',
            tableUsedFor: '用途',
            footer: '若要新增圖示，請從 src/assets/icons/index.ts 匯出，並在 icon-handoff-data.ts 中新增一列。',
        },
    },
} as const;

export default zhTW;
